export const DEVICE = {DESKTOP: 'Desktop', MOBILE: 'Mobile'} as const;

export interface MendelService {
  getVariantByExperimentName: ({name}: {name: string; forcedVariant?: string}) => Promise<string | undefined>;
  getScope: () => Promise<string>;
}
